import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from 'contexts/AuthContext';
import { SearchInput } from 'common/SearchInput';
import { filterByValue } from 'utils/helpers';
import { ManageAlertsModal } from 'components/Reader/Modals/ManageAlertsModal';
import { AlertListItem } from './AlertListItem';

export const AlertList = ({
    alerts,
    setSelectedAlert,
    fetchingAlertContent,
    tagData,
    selectedAlert,
    handleTagSelect,
    selectedTag,
    userId,
    refreshAlerts,
    isPublic,
    toggleSignInModal,
}) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { state, logout } = useContext(AuthContext);
    const [searchValue, setSearchValue] = useState('');
    const [visibleAlerts, setVisibleAlerts] = useState([]);
    const [manageAlertsModalOpen, setManageAlertsModalOpen] = useState(false);

    useEffect(() => {
        setVisibleAlerts(alerts);
    }, [alerts]);

    useEffect(() => {
        const newList = filterByValue(alerts, 'name', searchValue);
        setVisibleAlerts(newList);
    }, [searchValue]);

    const toggleManageAlertsModal = () => setManageAlertsModalOpen(!manageAlertsModalOpen);

    const handleAlertModalButton = () => {
        if (state.isAuthenticated || state.isReaderAuthenticated) {
            toggleManageAlertsModal();
        } else {
            toggleSignInModal();
        }
    };

    const handleLogout = () => {
        const readerInfo = sessionStorage.getItem('readerInfo');
        const hash = JSON.parse(readerInfo)?.hash;
        const id = JSON.parse(readerInfo)?.id;
        logout();

        if (pathname.includes('company/reader')) {
            navigate('/company/reader/signin');
            return;
        }

        if (id && hash) {
            navigate(`/public/reader/${id}?h=${hash}`);
            return;
        }

    };

    return (
        <div className="reader-column reader-alert-list">
            <div className="reader-column__wrapper">
                <div className="reader-column__header reader-alert-list__header">
                    <span>My Sources</span>
                    <i className="fa fa-plus" onClick={handleAlertModalButton} />
                </div>

                <div className="reader-column__searchbar reader-alert-list__searchbar">
                    <SearchInput
                        placeholder="Search by name"
                        value={searchValue}
                        classNames={['reader-column__input reader-alert-list__input']}
                        iconClassNames={['reader-alert-list__searchbar-icon']}
                        closeClassNames={['reader-alert-list__searchbar-icon']}
                        onChange={setSearchValue}
                        onClear={() => setSearchValue('')}
                    />
                </div>

                <div className="reader-column__body reader-alert-list__body">
                    {visibleAlerts.length < 1 ? (
                        <div style={{ padding: '0.375rem 0.75rem' }}>No alerts found</div>
                    ) : (
                        visibleAlerts.map((alert) => (
                            <AlertListItem
                                alert={alert}
                                key={alert.id}
                                tagData={tagData}
                                setSelectedAlert={setSelectedAlert}
                                fetchingAlertContent={fetchingAlertContent}
                                selectedAlert={selectedAlert}
                                handleTagSelect={handleTagSelect}
                                selectedTag={selectedTag}
                            />
                        ))
                    )}
                </div>

                <div className="reader-column__footer reader-alert-list__footer">
                    {visibleAlerts.length} {visibleAlerts.length === 1 ? 'Item' : 'Items'}
                </div>

                {(state.isAuthenticated || state.isReaderAuthenticated) &&
                    <div className="reader-column__footer">
                        <div style={{ display: 'inline' }} key="logout" className={'mobile-reader__nav-item'} onClick={handleLogout}>
                            <i className={'mobile-reader__nav-item-icon fa fa-lock'} />
                            <span style={{marginLeft: '5px'}} className="mobile-reader__nav-item-title">Logout</span>
                        </div>
                    </div>
                }

            </div>

            {manageAlertsModalOpen && (
                <ManageAlertsModal
                    isOpen={manageAlertsModalOpen}
                    toggle={toggleManageAlertsModal}
                    assignedAlerts={alerts}
                    isPublic={isPublic}
                    state={state}
                    refreshAlerts={refreshAlerts}
                    userId={userId}
                />
            )}
        </div>
    );
};
